import { Helmet } from "react-helmet-async";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Home.css";
import CollageGallery from "../components/CollageGallery";
import { Link } from "react-router-dom";
// import { Link } from "react-router-dom";
import {
  motion,
  AnimatePresence,
  useReducedMotion,
  useScroll,
  useTransform
} from "framer-motion";

import { useEffect, useState, useRef } from "react";
import Lenis from "@studio-freight/lenis";

/* ================= VIDEO ================= */
const videos = Array.from(
  { length: 10 },
  (_, i) =>
    `/web/Videos/${i + 1}.mp4`
);
const getVideoSource = () => {
  return window.innerWidth <= 768
    ? ["/videos/mobilevideo.mp4"]
    : ["/videos/mainvideo.mp4"];
};

/* ================= CLIENT LOGOS ================= */
const clientLogos = [
  "/ourproducts/AURealestate.png",
  "/ourproducts/FILATEX.png",
  "/ourproducts/Indigo.png",
  "/ourproducts/interOCEAN.jpg",
  "/ourproducts/M3M.png",
  "/ourproducts/Quikrlogo.png",
  "/ourproducts/Smartworld.jfif",
  "/ourproducts/SmartWorldonedxp.png",
  "/ourproducts/quint.png",
  "/ourproducts/TREVOCLogo.jpg",
  "/ourproducts/Upgrad.png"
];

/* ================= STATS RIBBON ================= */
const ribbonText =
  "100+ Happy Customers • 10 Million+ Sq. Ft. Designed & Delivered • 250+ Immersive Collaborations •";

/* ================= PRODUCTS ================= */

const products = [
  {
    href: "products/homes",
    img: "/img/products/homes.png",
    title: "Homes",
    desc: "Step into a home where every detail whispers luxury."
  },
  {
    href: "products/experience-center",
    img: "/img/products/Experince.png",
    title: "Experience Centers",
    desc: "Immersive brand storytelling environments."
  },
  {
    href: "products/offices",
    img: "/img/products/office.jpg",
    title: "Offices",
    desc: "Spaces that drive performance and creativity."
  },
  {
    href: "products/sample",
    img: "/img/products/samap.png",
    title: "Sample Apartments",
    desc: "Experience your space before it exists."
  }
];

/* ================= TESTIMONIALS ================= */                                                     

const testimonials = [
  {
    video: "https://www.youtube.com/embed/5Lkds1a1D70",
    text: "Association with SmartVizX has helped us hugely. It provides us nearly 20-25 minutes more with a potential buyer.",
    author: "Ankur Maheshwari",
  },
  {
    video: "https://www.youtube.com/embed/EvgCICJ-gqI",
    text: "I was amazed to see how they've set out to change the game completely...",
    author: "Chakrit Vorachacreyanan",
  },
  {
    video: "https://www.youtube.com/embed/LqRkETnIPC8",
    text: "I am super excited about what SmartVizX is developing...",
    author: "Ashwin Chadha",
  },
];

/* ================= MAGNETIC BUTTON ================= */

function Magnetic({ children }) {
  const ref = useRef(null);

  const move = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    ref.current.style.transform = `translate(${x * 0.25}px, ${y * 0.25}px)`;
  };

  const reset = () => {
    ref.current.style.transform = "translate(0,0)";
  };

  return (
    <div ref={ref} onMouseMove={move} onMouseLeave={reset}>
      {children}
    </div>
  );
}

/* ================= SHARED EASING ================= */
const EASE = [0.22, 1, 0.36, 1];

/* ================= SCROLL REVEAL =================
   Subtle fade-up when a block scrolls into view. Honors prefers-reduced-motion
   (renders the plain element with no animation). Used across homepage sections
   for one consistent motion language. */
function Reveal({ as = "div", className, style, children, delay = 0, y = 28 }) {
  const reduce = useReducedMotion();
  if (reduce) {
    const Plain = as;
    return (
      <Plain className={className} style={style}>
        {children}
      </Plain>
    );
  }
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      style={style}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.75, ease: EASE, delay }}
    >
      {children}
    </Tag>
  );
}

/* ================= SPEAKER ICON ================= */
function SpeakerIcon({ muted }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M11 5 6 9H2v6h4l5 4V5z" />
      {muted ? (
        <>
          <line x1="23" y1="9" x2="17" y2="15" />
          <line x1="17" y1="9" x2="23" y2="15" />
        </>
      ) : (
        <>
          <path d="M15.5 8.5a5 5 0 0 1 0 7" />
          <path d="M19.07 5.93a9 9 0 0 1 0 12.14" />
        </>
      )}
    </svg>
  );
}

function Home() {
  const reduceMotion = useReducedMotion();
const [isMuted, setIsMuted] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showRecentPosts] = useState(true);
const [videoSources, setVideoSources] = useState([]);



useEffect(() => {
  const updateVideo = () => {
    setVideoSources(getVideoSource());
  };

  updateVideo(); // initial load

  window.addEventListener("resize", updateVideo);

  return () => {
    window.removeEventListener("resize", updateVideo);
  };
}, []);
  /* SMOOTH SCROLL (Lenis) - buttery easeOutExpo glide, properly torn down on
     unmount, and disabled when the user prefers reduced motion. */
  useEffect(() => {
    if (reduceMotion) return;
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easeOutExpo
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.6,
    });
    let rafId;
    const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(rafId); lenis.destroy(); };
  }, [reduceMotion]);

  /* HIDE PAGE SCROLLBAR (homepage only) - scroll still works */
  useEffect(() => {
    document.documentElement.classList.add("hide-scrollbar");
    return () => document.documentElement.classList.remove("hide-scrollbar");
  }, []);

  /* LOADER */
  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2500);
    return () => clearTimeout(t);
  }, []);


  const [cityForm, setCityForm] = useState({
  name: "",
  mobile: "",
  email: "",
  city: "",
});

const handleCityChange = (e) => {
  setCityForm({
    ...cityForm,
    [e.target.name]: e.target.value,
  });
};

const handleCitySubmit = (e) => {
  e.preventDefault();

  const { name, mobile, email, city } = cityForm;

  if (!name || !mobile || !city) {
    alert("Please fill required fields");
    return;
  }

  const text = `Hi SmartvizX Team 👋

📌 New City Inquiry

👤 Name: ${name}
📱 Mobile: ${mobile}
📧 Email: ${email || "Not provided"}
📍 City: ${city}

🕒 Time: ${new Date().toLocaleString()}
🌐 Source: Home Page City Form`;

  const url = `https://wa.me/919910661689?text=${encodeURIComponent(text)}`;

  window.open(url, "_blank");
};
  /* CURSOR */
  const cursorRef = useRef(null);
  useEffect(() => {
    const move = (e) =>
      cursorRef.current.style.transform =
        `translate(${e.clientX}px, ${e.clientY}px)`;
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  /* HERO VIDEO */
  const [currentVideo, setCurrentVideo] = useState(0);
useEffect(() => {
  if (videoSources.length <= 1) return;

  const i = setInterval(() => {
    setCurrentVideo((p) => (p + 1) % videoSources.length);
  }, 9000);

  return () => clearInterval(i);
}, [videoSources]);

  /* MARQUEE - defer video downloads until the section is near the viewport
     (visuals/animation unchanged; only network timing changes) */
  const marqueeRef = useRef(null);
  const [marqueeLive, setMarqueeLive] = useState(false);
  useEffect(() => {
    const el = marqueeRef.current;
    if (!el || marqueeLive) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setMarqueeLive(true);
          io.disconnect();
        }
      },
      { rootMargin: "800px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [marqueeLive]);

  /* OUR WORK - pinned frame; vertical scroll drives the cards horizontally.
     The section is tall (CSS height), the inner wrapper is sticky, and the
     track translates from 0 to -(overflow) as you scroll through the section. */
  const workSectionRef = useRef(null);
  const trackRef = useRef(null);
  const [trackTravel, setTrackTravel] = useState(0);
  const [pinHeight, setPinHeight] = useState(null); // px; null => let CSS decide (mobile/reduced)
  const [workRevealEnd, setWorkRevealEnd] = useState(0.85);
  useEffect(() => {
    const measure = () => {
      const track = trackRef.current;
      if (!track) return;
      // Pin the reveal on every width (mobile too); only reduced-motion opts out.
      if (reduceMotion) {
        setTrackTravel(0);
        setPinHeight(null);
        setWorkRevealEnd(0.85);
        return;
      }

      const isMobileViewport = window.innerWidth <= 768;
      const overflow = Math.max(0, track.scrollWidth - (track.parentElement?.clientWidth || 0));
      const trackStyles = window.getComputedStyle(track);
      const trailingPadding = parseFloat(trackStyles.paddingRight) || 0;
      const revealEnd = isMobileViewport ? 1 : 0.85;
      const effectiveTravel = isMobileViewport
        ? Math.max(0, overflow - trailingPadding)
        : overflow;

      setTrackTravel(effectiveTravel);
      setWorkRevealEnd(revealEnd);
      // On phones, release into vertical scroll as soon as the last card is fully visible.
      setPinHeight(window.innerHeight + effectiveTravel / revealEnd);
    };
    measure();
    window.addEventListener("resize", measure);
    const t = setTimeout(measure, 600); // after layout settles
    return () => { window.removeEventListener("resize", measure); clearTimeout(t); };
  }, [reduceMotion]);
  const { scrollYProgress: workProgress } = useScroll({
    target: workSectionRef,
    offset: ["start start", "end end"],
  });
  const trackX = useTransform(workProgress, [0, workRevealEnd], [0, -trackTravel]);

  return (
    <>
      <Helmet><title>SmartVizX</title></Helmet>

      {/* LOADER */}
      {loading && (
        <div className="studio-loader">
      <motion.div
  initial={{ scale: .8, opacity: 0 }}
  animate={{ scale: 1, opacity: 1 }}
  className="studio-loader-text"
>
  <img src="/img/finllogoa.png" alt="SmartVizX Logo" />
</motion.div>
        </div>
      )}

      <div className="cursor" ref={cursorRef} />
      <Navbar />

      {/* HERO */}
      <section className="hero">
       <AnimatePresence mode="wait">
  <motion.video
    key={videoSources[currentVideo]}
    src={videoSources[currentVideo]}
    poster={videoSources[currentVideo]?.replace(".mp4", "-poster.jpg")}
    autoPlay
    muted
    loop
    playsInline
    preload="metadata"
    className="hero-video"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  />
</AnimatePresence>

<button
  className="sound-toggle-btn"
  onClick={() => {
    const video = document.querySelector(".hero-video");
    if (video) {
      video.muted = !video.muted;
      setIsMuted(video.muted);
    }
  }}
>
  <SpeakerIcon muted={isMuted} />
  <span>{isMuted ? "Sound Off" : "Sound On"}</span>
</button>
        {/* <div className="hero-overlay" /> */}
        <div className="hero-vignette" />

        <motion.div className="hero-content">
          {/* <h1>Designing Experiences.<br />Building Emotion.</h1> */}

          <div className="hero-buttons">
            <Magnetic>
              {/* <a href="products" className="lux-btn">Explore Work</a> */}
            </Magnetic>

            <Magnetic>
              {/* <button className="lux-btn glass" onClick={()=>setShowModal(true)}>
                Connect With Us
              </button> */}
            </Magnetic>
          </div>
        </motion.div>

        <div className="film-grain" />
      </section>

     
<motion.section
  className="split-hero"
  initial="rest"
  whileHover="hover"
  animate="rest"
>
  {/* LEFT */}
  <motion.div 
    className="hero-half"
  
  >
<motion.img
  src="/web/1.jpg"
  alt="Project"
  className="hero-image"
  variants={{
    rest: { scale: 1 },
    hover: {
      scale: 1.08,
      x: -12,
      y: -8,
      transition: { duration: 0.7, ease: EASE }
    }
  }}
/>

    <motion.div
      className="overlay-dark"
      variants={{ rest: { opacity: 0 }, hover: { opacity: 1 } }}
      transition={{ duration: 0.55, ease: EASE }}
    />

    <motion.div
      className="hero-text"
      variants={{
        rest: { y: 40, opacity: 0 },
        hover: { y: 0, opacity: 1 }
      }}
      transition={{ duration: 0.8 }}
    >
      <h2 className="h2">Immersive Design</h2>
      <p>Experience architecture in motion.</p>
    </motion.div>
  </motion.div>


  {/* RIGHT */}
  <motion.div 
    className="hero-half"
   
  >
  <motion.img
  src="/web/2.png"
  alt="Project 2"
  className="hero-image"
  variants={{
    rest: { scale: 1 },
    hover: {
      scale: 1.08,
      x: 12,
      y: -8,
      transition: { duration: 0.7, ease: EASE }
    }
  }}
/>

    <motion.div
      className="overlay-dark"
      variants={{ rest: { opacity: 0 }, hover: { opacity: 1 } }}
      transition={{ duration: 0.55, ease: EASE }}
    />

    <motion.div
      className="hero-text"
      variants={{
        rest: { y: 40, opacity: 0 },
        hover: { y: 0, opacity: 1 }
      }}
      transition={{ duration: 0.8 }}
    >
      <h2>Quiet Luxury</h2>
      <p>Where emotion meets space.</p>
    </motion.div>
  </motion.div>

</motion.section>




<section className="luxury-video-section" ref={marqueeRef}>

  <div className="video-track">
    {[...videos, ...videos].map((src, index) => (
      <div className="video-card" key={index}>
        <video
          src={marqueeLive ? src : undefined}
          poster={src.replace(".mp4", "-poster.jpg")}
          autoPlay
          loop
          muted
          playsInline
          preload="none"
        />
      </div>
    ))}
  </div>

</section>


      {/* HORIZONTAL PRODUCTS - pinned scroll reveal */}
      <section
        className={"horizontal-section" + (reduceMotion ? " no-pin" : "")}
        ref={workSectionRef}
        style={pinHeight ? { height: `${pinHeight}px` } : undefined}
      >
        <div className="sticky-wrapper">
          <Reveal as="h1" className="head">Our Work</Reveal>
          <div className="horizontal-scroll-container">
            <motion.div
              className="horizontal-track"
              ref={trackRef}
              style={reduceMotion ? undefined : { x: trackX }}
            >
              {products.map((p, i) => (
                <Link key={i} to={`/${p.href}`} className="product-card">
                  <div className="product-image-wrap">
                    <img src={p.img} alt={p.title} loading="lazy" decoding="async" />
                  </div>
                  <div className="product-info">
                    <h3>{p.title}</h3>
                    <p>{p.desc}</p>
                  </div>
                </Link>
              ))}
            </motion.div>
          </div>
          <div className="hscroll-progress" aria-hidden="true">
            <motion.div
              className="hscroll-progress-bar"
              style={reduceMotion ? { transform: "scaleX(1)" } : { scaleX: workProgress }}
            />
          </div>
        </div>
      </section>

 {/* COMPANY TEXT */}
      <section className="company-text-section">
        <div className="container">
          <Reveal as="p">
            We design and build innovative spaces using proprietary immersive
            technology ensuring that performance meets emotion. From flagship
            offices to experience centers and bespoke residences, we create
            environments that embody a brand’s story and elevate how people feel.
          </Reveal>

<Reveal as="h3" className="magic-heading" delay={0.1}>
  This is where the magic starts
</Reveal>
         <div className="ribbon">
  <div className="ribbon-track">
    {Array.from({ length: 6 }).map((_, i) => (
      <span key={i} aria-hidden={i > 0}>{ribbonText}</span>
    ))}
  </div>
</div>

        </div>

       <div className="client-logo-slider">
  <div className="clogo-track">
    {[...clientLogos, ...clientLogos].map((img, i) => (
      <div className="clogo" key={i} aria-hidden={i >= clientLogos.length}>
        <img src={img} alt="" loading="lazy" decoding="async" />
      </div>
    ))}
  </div>
</div>
      </section>


    <CollageGallery />
     {/* RECENT POSTS */}
{showRecentPosts && (
  <section className="recent-posts-section container">

    <Reveal as="div" className="recent-header">
      <h2 className="recent-title">Recent Posts</h2>
      <p className="recent-sub">
        Ideas, innovation and immersive design thinking from our team.
      </p>
    </Reveal>
<Reveal as="div" className="recent-grid">
  {[
     {
    link: "blog/A-Blueprint",
    // img: 'blog1.jpg',
    title: "Designing Immersive Experience Centers: A Blueprint for Emotional Impact",
    author: 'Gautam Tewari',
    // date: '10 July, 2025',
  },
      {
    link: 'blog/Boosting-Workplace',
    title: 'Boosting Workplace Performance: Lessons from High-Performance Office Environments',
    author: 'Gautam Tewari',
  },
     {
    link: 'blog/Trezi',
    // img: 'blog3.jpg',
    title: 'Smartvizx in Action: How Virtual Walkthroughs Revolutionize Design and Delivery',
    author: 'Gautam Tewari',
    // date: '25 June, 2025',
  },
    {
      link: "blog/Sustainable",
      title:
        "How Can Technology Save Environment And Give Our Planet A Fresh Lease of Life!",
      author: "Gautam Tewari",
    },
  ].map((p, i) => (
    <Link
      key={i}
      to={`/${p.link}`}
      className="recent-card"
    >
      <div className="recent-card-accent" />

      <div className="recent-card-content">
        <p className="recent-card-title">{p.title}</p>
        <p className="recent-card-author">By {p.author}</p>
      </div>

      <div className="recent-card-arrow">→</div>
    </Link>
  ))}
</Reveal>

   <div className="recent-view">
  <Link to="/blog" className="recent-btn">
    Explore All Articles
  </Link>
</div>

  </section>
)}


{/* CITIES WE SERVE SECTION */}
<section className="cities-section">

  <div className="cities-container">

    <div className="cities-left">
      <Reveal as="h2">Cities We Served</Reveal>
      <Reveal as="p" delay={0.08}>
        Bringing bespoke design experiences across India's leading cities.
      </Reveal>

      <img
        src="map.png"
        alt="India Map"
        className="india-map"
        loading="lazy"
        decoding="async"
      />
    </div>

    <Reveal as="div" className="cities-form-wrapper" y={36}>

      <div className="cities-form">

        <h3>Talk to our design team </h3>

        <form onSubmit={handleCitySubmit}>

  <div className="form-group">
    <input
      type="text"
      name="name"
      required
      onChange={handleCityChange}
    />
    <label>Name*</label>
  </div>

  <div className="form-group">
    <input
      type="tel"
      name="mobile"
      required
      onChange={handleCityChange}
      // placeholder="+91 98xxxxxxx"
    />
    <label>Mobile*</label>
  </div>

  <div className="form-group">
    <input
      type="email"
      name="email"
      onChange={handleCityChange}
    />
    <label>Email (Optional)</label>
  </div>

  <div className="form-group">
    <select
      name="city"
      required
      onChange={handleCityChange}
    >
      <option value="">Choose City</option>
      <option>New Delhi</option>
      <option>Noida</option>
      <option>Gurgaon</option>
      <option>Mumbai</option>
      <option>Pune</option>
      <option>Bangalore</option>
    </select>
  </div>

  <button type="submit" className="cities-btn">
    Connect Now
  </button>

</form>

      </div>

    </Reveal>

  </div>

</section>
      <Footer />

      {showModal && (
        <div className="modal-overlay" onClick={()=>setShowModal(false)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <button onClick={()=>setShowModal(false)}>✕</button>
            <h3>Contact Us</h3>
            <form onSubmit={(e)=>{
              e.preventDefault();
              const name=e.target.name.value;
              window.open(`https://wa.me/8527417771?text=Hi I'm ${name}`,"_blank");
            }}>
              <input name="name" placeholder="Name" required/>
              <input name="email" placeholder="Email" required/>
              <textarea name="message" placeholder="Message"/>
              <button type="submit">Send</button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default Home;